module.exports = __webpack_public_path__ + "assets/froala-editor.a1bd0adb.svg";